<div class="p-jc-center">
  <full-calendar [options]="calendarOptions"></full-calendar>
</div>
